/*eslint-disable no-unused-vars */
/*eslint-disable react-hooks/exhaustive-deps*/
import React, { useState, useEffect } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import MetisMenu from '@metismenu/react';
import classnames from 'classnames';

import { CompanyId, JobRole, USER_ROLE } from '../../../constants';
import LocalstorageService from '../../../helpers/localstorage-service';
import AgentService from '../../../services/agent';

let companyId = 0;

function SidebarContent({ toggleMenuCallback }) {
  const { t } = useTranslation();
  const location = useLocation();
  const { leftSideBarType } = useSelector((state) => state.Layout);

  const [roleId, setRoleId] = useState();
  const [routePath, setRoutePath] = useState(location.pathname);
  const [subMenuShown, setSubMenuShown] = useState(false);
  const [subEmpMenuShown, setSubEmpMenuShown] = useState(false);
  const [subReportMenuShown, setSubReportMenuShown] = useState(false);
  const [subProfitMenuShown, setSubProfitMenuShown] = useState(false);
  const [subAdminMenuShown, setSubAdminMenuShown] = useState(false);
  const [subAlertsMenuShown, setSubAlertsMenuShown] = useState(false);
  const [subLocationsMenuShown, setSubLocationsMenuShown] = useState(false);
  const [agentCount, setAgentCount] = useState(0);

  const isCompanyAdmin = roleId === USER_ROLE.COMPANY_ADMIN;

  useEffect(() => {
    const jobRole = LocalstorageService.getItem(JobRole);
    setRoleId(jobRole);
    setSubMenuShown(routePath.substring(0, '/agent-activity'.length) === '/agent-activity');
    setSubEmpMenuShown(routePath.substring(0, '/employee-activity'.length) === '/employee-activity' || routePath.startsWith('/employee/'));
    setSubReportMenuShown(routePath.substring(0, '/report'.length) === '/report');
    setSubProfitMenuShown(routePath.substring(0, '/profitability'.length) === '/profitability');
    setSubAdminMenuShown(routePath.substring(0, '/admin'.length) === '/admin' || routePath.startsWith('/company') || routePath.startsWith('/bank') || routePath === '/loading-terminal/alternative' || routePath.startsWith('/account'));
    setSubLocationsMenuShown(routePath.startsWith('/locations') || routePath.startsWith('/terminal'));
    companyId = LocalstorageService.getItem(CompanyId);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // שליפת מספר סוכנים עבור מנהל חברה
  useEffect(() => {
    if (roleId === USER_ROLE.COMPANY_ADMIN && companyId && companyId !== 0) {
      AgentService.listAgent({ pageNo: 1, pageSize: 1, companyId })
        .then(res => {
          if (res?.status === 200) {
            setAgentCount(res.totalCount || 0);
          }
        })
        .catch(() => {});
    }
  }, [roleId]);

  useEffect(() => {
    const pathName = location.pathname;
    setRoutePath(pathName);

    if (isCompanyAdmin) {
      // מנהל חברה — התנהגות אקורדיון: רק תפריט אחד פתוח
      closeAllSubMenus();
      if (pathName.startsWith('/employee-activity') || pathName.startsWith('/employee/')) {
        setSubEmpMenuShown(true);
      } else if (pathName.startsWith('/locations') || pathName.startsWith('/terminal')) {
        setSubLocationsMenuShown(true);
      } else if (pathName.startsWith('/report')) {
        setSubReportMenuShown(true);
      } else if (pathName.startsWith('/profitability')) {
        setSubProfitMenuShown(true);
      } else if (pathName.startsWith('/agent-activity')) {
        setSubMenuShown(true);
      } else if (
        (pathName.startsWith('/admin') && pathName !== '/admin/send-message') ||
        pathName.startsWith('/company') ||
        pathName.startsWith('/bank') ||
        pathName === '/loading-terminal/alternative' ||
        pathName.startsWith('/account') ||
        pathName.startsWith('/agent/')
      ) {
        setSubAdminMenuShown(true);
      }
    } else {
      // שאר הרולים — התנהגות מקורית
      if (pathName === '/agent-activity/bank-withdrawal' || pathName === '/agent-activity/split-money') {
        setSubEmpMenuShown(false);
        setSubReportMenuShown(false);
      } else if (
        pathName === '/employee-activity/bank-withdrawal' ||
        pathName === '/employee-activity/charging-terminal' ||
        pathName === '/employee-activity/split-money' ||
        pathName === '/employee-activity/loading-terminal' ||
        pathName === '/employee-activity/withdrawal-terminal'
      ) {
        setSubMenuShown(false);
        setSubReportMenuShown(false);
      } else if (
        pathName === '/report/agent-cash-expense' ||
        pathName === '/report/reference' ||
        pathName === '/report/terminal' ||
        pathName === '/report/withdrawal-count' ||
        pathName === '/report/loading-gap' ||
        pathName === '/report/employee-loading-gaps-cumulative' ||
        pathName === '/report/check-flow' ||
        pathName === '/report/employee-balance' ||
        pathName === '/report/batch-lines-reconciliation' ||
        pathName === '/report/casponet-invoice-verification' ||
        pathName === '/report/missing-invoice-batches'
      ) {
        setSubMenuShown(false);
        setSubEmpMenuShown(false);
      } else {
        setSubMenuShown(false);
        setSubEmpMenuShown(false);
        setSubReportMenuShown(false);
      }
    }

    leftSideBarType === 'condensed' && toggleMenuCallback();
  }, [location]);

  // סגירת כל תפריטי המשנה (התנהגות אקורדיון עבור מנהל חברה)
  const closeAllSubMenus = () => {
    setSubMenuShown(false);
    setSubEmpMenuShown(false);
    setSubReportMenuShown(false);
    setSubProfitMenuShown(false);
    setSubAdminMenuShown(false);
    setSubAlertsMenuShown(false);
    setSubLocationsMenuShown(false);
  };

  // פתיחת/סגירת תפריט עם סגירת האחרים (מנהל חברה בלבד)
  const toggleAccordion = (setter, currentValue) => {
    const newValue = !currentValue;
    closeAllSubMenus();
    if (newValue) setter(true);
  };

  // =====================================================
  // תפריט מנהל חברה — סדר ומבנה חדש
  // =====================================================
  const renderCompanyAdminMenu = () => (
    <>
      {/* 1. לוח מחוונים */}
      <li className={routePath.startsWith('/dashboard') ? 'mm-active' : ''}>
        <NavLink to="/dashboard" className="waves-effect">
          <i className="ri-dashboard-line"></i>
          <span className="ms-1">{t('DASHBOARD.TITLE')}</span>
        </NavLink>
      </li>

      {/* 2. טעינות עובדים ליום */}
      <li className={routePath === '/loading-terminal/terminal-loads' ? 'mm-active' : ''}>
        <NavLink to="/loading-terminal/terminal-loads" className="waves-effect">
          <i className="ri-currency-line"></i>
          <span className="ms-1">{t('EMPLOYEE_LOADS.TITLE')}</span>
        </NavLink>
      </li>

      {/* 3. פעילות עובדים (כולל עובדים כתת-פריט) */}
      {companyId !== 0 && (
        <li
          className={classnames(
            'subMenu',
            routePath.startsWith('/employee-activity') || routePath.startsWith('/employee/') || subEmpMenuShown
              ? 'mm-active cust-mm-active'
              : '',
          )}
        >
          <Link
            to="#"
            className={classnames('has-arrow', subEmpMenuShown ? 'cust-has-arrow' : '')}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              toggleAccordion(setSubEmpMenuShown, subEmpMenuShown);
            }}
          >
            <i className="ri-contacts-line"></i>
            <span className="ms-1">{t('EMP_ACTIVITY')}</span>
          </Link>

          <ul className={classnames('mm-collapse', subEmpMenuShown ? 'mm-show cust-mm-show' : '')}
            style={subEmpMenuShown ? { backgroundColor: '#f0f1f3', borderRadius: '4px' } : {}}>
            <li className={classnames(routePath === '/employee-activity/bank-withdrawal' ? 'mm-active' : '')}>
              <NavLink to="/employee-activity/bank-withdrawal" className="waves-effect">
                <i className="ri-uninstall-line"></i>
                <span className="ms-1">{t('BANK_WITHDRAWAL.TITLE')}</span>
              </NavLink>
            </li>

            <li className={classnames(routePath === '/employee-activity/charging-terminal' ? 'mm-active' : '')}>
              <NavLink to="/employee-activity/charging-terminal" className="waves-effect">
                <i className="ri-fridge-line"></i>
                <span className="ms-1">{t('CHARGE_TERMINAL.TITLE')}</span>
              </NavLink>
            </li>

            <li className={classnames(routePath === '/employee-activity/split-money' ? 'mm-active' : '')}>
              <NavLink to="/employee-activity/split-money" className="waves-effect">
                <i className="ri-refund-2-line"></i>
                <span className="ms-1">{t('SPLIT_MONEY.TITLE')}</span>
              </NavLink>
            </li>

            <li className={classnames(routePath === '/employee-activity/withdrawal-terminal' ? 'mm-active' : '')}>
              <NavLink to="/employee-activity/withdrawal-terminal" className="waves-effect">
                <i className="ri-fridge-line"></i>
                <span className="ms-1">{t('WITHDRAWAL_TERMINAL')}</span>
              </NavLink>
            </li>

            {/* עובדים — הועבר לתוך פעילות עובדים */}
            <li className={classnames(routePath.startsWith('/employee/') ? 'mm-active' : '')}>
              <NavLink to="/employee/list" className="waves-effect">
                <i className="ri-user-2-line"></i>
                <span className="ms-1">{t('EMPLOYEE.TITLE')}</span>
              </NavLink>
            </li>
          </ul>
        </li>
      )}

      {/* 4. מקומות (מקום + מסוף) */}
      {companyId !== 0 && (
        <li
          className={classnames(
            'subMenu',
            routePath.startsWith('/locations') || routePath.startsWith('/terminal') || subLocationsMenuShown
              ? 'mm-active cust-mm-active'
              : '',
          )}
        >
          <Link
            to="#"
            className={classnames('has-arrow', subLocationsMenuShown ? 'cust-has-arrow' : '')}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              toggleAccordion(setSubLocationsMenuShown, subLocationsMenuShown);
            }}
          >
            <i className="ri-map-pin-5-line"></i>
            <span className="ms-1">מקומות</span>
          </Link>

          <ul className={classnames('mm-collapse', subLocationsMenuShown ? 'mm-show cust-mm-show' : '')}
            style={subLocationsMenuShown ? { backgroundColor: '#f0f1f3', borderRadius: '4px' } : {}}>
            <li className={classnames(routePath.startsWith('/locations') ? 'mm-active' : '')}>
              <NavLink to="/locations/list" className="waves-effect">
                <i className="ri-map-pin-5-line"></i>
                <span className="ms-1">{t('LOCATION.TITLE')}</span>
              </NavLink>
            </li>

            <li className={classnames(routePath.startsWith('/terminal') ? 'mm-active' : '')}>
              <NavLink to="/terminal/list" className="waves-effect">
                <i className="ri-safe-line"></i>
                <span className="ms-1">{t('MACHINE.TITLE')}</span>
              </NavLink>
            </li>
          </ul>
        </li>
      )}

      {/* 5. טעינת מסופים ליום */}
      <li className={routePath === '/loading-terminal/list' ? 'mm-active' : ''}>
        <NavLink to="/loading-terminal/list" className="waves-effect">
          <i className="ri-currency-line"></i>
          <span className="ms-1">{t('LOADING_TERMINAL.TITLE')}</span>
        </NavLink>
      </li>

      {/* 6. ימים מיוחדים */}
      {companyId !== 0 && (
        <li className={routePath.startsWith('/special-days') ? 'mm-active' : ''}>
          <NavLink to="/special-days/list" className="waves-effect">
            <i className="ri-calendar-2-line"></i>
            <span className="ms-1">{t('SPECIAL_DAYS.TITLE')}</span>
          </NavLink>
        </li>
      )}

      {/* 7. הוצאה במזומן */}
      <li className={routePath === '/cash-expense' ? 'mm-active' : ''}>
        <NavLink to="/cash-expense/list" className="waves-effect">
          <i className="ri-currency-line"></i>
          <span className="ms-1">{t('CASHEXPENSE.TITLE')}</span>
        </NavLink>
      </li>

      {/* 8. דוחות */}
      {companyId !== 0 && (
        <li
          className={classnames(
            'subMenu',
            routePath.startsWith('/report') || subReportMenuShown
              ? 'mm-active cust-mm-active'
              : '',
          )}
        >
          <Link
            to="#"
            className={classnames('has-arrow', subReportMenuShown ? 'cust-has-arrow' : '')}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              toggleAccordion(setSubReportMenuShown, subReportMenuShown);
            }}
          >
            <i className="ri-file-chart-line"></i>
            <span className="ms-1">{t('REPORT.TITLE')}</span>
          </Link>

          <ul className={classnames('mm-collapse', subReportMenuShown ? 'mm-show cust-mm-show' : '')}
            style={subReportMenuShown ? { backgroundColor: '#f0f1f3', borderRadius: '4px' } : {}}>
            <li className={classnames(routePath === '/report/agent-cash-expense' ? 'mm-active' : '')}>
              <NavLink to="/report/agent-cash-expense" className="waves-effect">
                <i className="ri-wallet-3-line"></i>
                <span className="ms-1">{t('REPORT.AGENTCASHEXPENSE')}</span>
              </NavLink>
            </li>

            <li className={classnames(routePath === '/report/reference' ? 'mm-active' : '')}>
              <NavLink to="/report/reference" className="waves-effect">
                <i className="ri-survey-line"></i>
                <span className="ms-1">{t('REPORT.REPORT_REFER')}</span>
              </NavLink>
            </li>

            <li className={classnames(routePath === '/report/terminal' ? 'mm-active' : '')}>
              <NavLink to="/report/terminal" className="waves-effect">
                <i className="ri-list-check-2"></i>
                <span className="ms-1">{t('REPORT.TERMINAL_REPORT')}</span>
              </NavLink>
            </li>

            <li className={classnames(routePath === '/report/withdrawal-count' ? 'mm-active' : '')}>
              <NavLink to="/report/withdrawal-count" className="waves-effect">
                <i className="ri-bar-chart-2-line"></i>
                <span className="ms-1">{t('WITHDRAWAL_REPORT.TITLE')}</span>
              </NavLink>
            </li>

            <li className={classnames(routePath === '/report/loading-gap' ? 'mm-active' : '')}>
              <NavLink to="/report/loading-gap" className="waves-effect">
                <i className="ri-funds-box-line"></i>
                <span className="ms-1">פערים בין טעינות</span>
              </NavLink>
            </li>

            <li className={classnames(routePath === '/report/employee-loading-gaps-cumulative' ? 'mm-active' : '')}>
              <NavLink to="/report/employee-loading-gaps-cumulative" className="waves-effect">
                <i className="ri-line-chart-line"></i>
                <span className="ms-1">פערים מצטבר פר עובד</span>
              </NavLink>
            </li>

            <li className={classnames(routePath === '/report/check-flow' ? 'mm-active' : '')}>
              <NavLink to="/report/check-flow" className="waves-effect">
                <i className="ri-exchange-funds-line"></i>
                <span className="ms-1">זרימת כסף</span>
              </NavLink>
            </li>

            <li className={classnames(routePath === '/report/employee-balance' ? 'mm-active' : '')}>
              <NavLink to="/report/employee-balance" className="waves-effect">
                <i className="ri-money-dollar-circle-line"></i>
                <span className="ms-1">יתרת עובדים</span>
              </NavLink>
            </li>

            <li className={classnames(routePath === '/report/batch-lines-reconciliation' ? 'mm-active' : '')}>
              <NavLink to="/report/batch-lines-reconciliation" className="waves-effect">
                <i className="ri-file-list-3-line"></i>
                <span className="ms-1">הצלבת אצוות חשבוניות</span>
              </NavLink>
            </li>

            <li className={classnames(routePath === '/report/casponet-invoice-verification' ? 'mm-active' : '')}>
              <NavLink to="/report/casponet-invoice-verification" className="waves-effect">
                <i className="ri-file-check-line"></i>
                <span className="ms-1">אימות חשבונית כספונט</span>
              </NavLink>
            </li>

            <li className={classnames(routePath === '/report/missing-invoice-batches' ? 'mm-active' : '')}>
              <NavLink to="/report/missing-invoice-batches" className="waves-effect">
                <i className="ri-error-warning-line"></i>
                <span className="ms-1">אצוות חסרות מ-Casponet</span>
              </NavLink>
            </li>
          </ul>
        </li>
      )}

      {/* 9. רווחיות */}
      {companyId !== 0 && (
        <li
          className={classnames(
            'subMenu',
            routePath.startsWith('/profitability') || subProfitMenuShown
              ? 'mm-active cust-mm-active'
              : '',
          )}
        >
          <Link
            to="#"
            className={classnames('has-arrow', subProfitMenuShown ? 'cust-has-arrow' : '')}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              toggleAccordion(setSubProfitMenuShown, subProfitMenuShown);
            }}
          >
            <i className="ri-line-chart-line"></i>
            <span className="ms-1">{t('PROFITABILITY.TITLE')}</span>
          </Link>

          <ul className={classnames('mm-collapse', subProfitMenuShown ? 'mm-show cust-mm-show' : '')}
            style={subProfitMenuShown ? { backgroundColor: '#f0f1f3', borderRadius: '4px' } : {}}>
            {/* 1. שיוך חשבוניות סרוקות */}
            <li className={classnames(routePath === '/profitability/invoice-scan' ? 'mm-active' : '')}>
              <NavLink to="/profitability/invoice-scan" className="waves-effect">
                <i className="ri-scan-2-line"></i>
                <span className="ms-1">{t('PROFITABILITY.INVOICE_SCAN')}</span>
              </NavLink>
            </li>
            {/* 2. רווחיות לחודש */}
            <li className={classnames(routePath === '/profitability/monthly-report' ? 'mm-active' : '')}>
              <NavLink to="/profitability/monthly-report" className="waves-effect">
                <i className="ri-bar-chart-grouped-line"></i>
                <span className="ms-1">{t('PROFITABILITY.MONTHLY_REPORT')}</span>
              </NavLink>
            </li>
            {/* 3. תשלום למקומות */}
            <li className={classnames(routePath === '/profitability/payment-schedule' ? 'mm-active' : '')}>
              <NavLink to="/profitability/payment-schedule" className="waves-effect">
                <i className="ri-calendar-check-line"></i>
                <span className="ms-1">{t('PROFITABILITY.PAYMENT_SCHEDULE')}</span>
              </NavLink>
            </li>
            {/* 4. חשבוניות מקומות */}
            <li className={classnames(routePath === '/profitability/invoices' ? 'mm-active' : '')}>
              <NavLink to="/profitability/invoices" className="waves-effect">
                <i className="ri-file-list-3-line"></i>
                <span className="ms-1">{t('PROFITABILITY.INVOICES')}</span>
              </NavLink>
            </li>
            {/* 5. חשבוניות ספקים */}
            <li className={classnames(routePath === '/profitability/expenses' ? 'mm-active' : '')}>
              <NavLink to="/profitability/expenses" className="waves-effect">
                <i className="ri-wallet-2-line"></i>
                <span className="ms-1">{t('PROFITABILITY.EXPENSES')}</span>
              </NavLink>
            </li>
            {/* 5.5 חשבוניות הכנסה (RevenueInvoice) */}
            <li className={classnames(routePath === '/profitability/revenue-invoices' ? 'mm-active' : '')}>
              <NavLink to="/profitability/revenue-invoices" className="waves-effect">
                <i className="ri-money-dollar-circle-line"></i>
                <span className="ms-1">{t('PROFITABILITY.REVENUE_INVOICES')}</span>
              </NavLink>
            </li>
            {/* 6. שכר עובדים */}
            <li className={classnames(routePath === '/profitability/salary' ? 'mm-active' : '')}>
              <NavLink to="/profitability/salary" className="waves-effect">
                <i className="ri-user-star-line"></i>
                <span className="ms-1">{t('PROFITABILITY.SALARY')}</span>
              </NavLink>
            </li>
            {/* 7. ניהול ריכוז ספקים */}
            <li className={classnames(routePath === '/profitability/location-groups' ? 'mm-active' : '')}>
              <NavLink to="/profitability/location-groups" className="waves-effect">
                <i className="ri-map-pin-2-line"></i>
                <span className="ms-1">{t('PROFITABILITY.LOCATION_GROUPS')}</span>
              </NavLink>
            </li>
          </ul>
        </li>
      )}

      {/* 10. פעילות סוכנים — רק אם יותר מסוכן אחד */}
      {companyId !== 0 && agentCount > 1 && (
        <li
          className={classnames(
            'subMenu',
            routePath.startsWith('/agent-activity') || subMenuShown
              ? 'mm-active cust-mm-active'
              : '',
          )}
        >
          <Link
            to="#"
            className={classnames('has-arrow', subMenuShown ? 'cust-has-arrow' : '')}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              toggleAccordion(setSubMenuShown, subMenuShown);
            }}
          >
            <i className="ri-contacts-fill"></i>
            <span className="ms-1">{t('AGENT_ACTIVITY')}</span>
          </Link>

          <ul className={classnames('mm-collapse', subMenuShown ? 'mm-show cust-mm-show' : '')}
            style={subMenuShown ? { backgroundColor: '#f0f1f3', borderRadius: '4px' } : {}}>
            <li className={classnames(routePath === '/agent-activity/bank-withdrawal' ? 'mm-active' : '')}>
              <NavLink to="/agent-activity/bank-withdrawal" className="waves-effect">
                <i className="ri-uninstall-line"></i>
                <span className="ms-1">{t('BANK_WITHDRAWAL.TITLE')}</span>
              </NavLink>
            </li>

            <li className={classnames(routePath === '/agent-activity/split-money' ? 'mm-active' : '')}>
              <NavLink to="/agent-activity/split-money" className="waves-effect">
                <i className="ri-refund-2-line"></i>
                <span className="ms-1">{t('SPLIT_MONEY.TITLE')}</span>
              </NavLink>
            </li>
          </ul>
        </li>
      )}

      {/* רווח */}
      <li className="menu-gap"></li>

      {/* 11. שליחת הודעות */}
      <li className={routePath === '/admin/send-message' ? 'mm-active' : ''}>
        <NavLink to="/admin/send-message" className="waves-effect">
          <i className="ri-send-plane-line"></i>
          <span className="ms-1">שליחת הודעות</span>
        </NavLink>
      </li>

      {/* קו הפרדה */}
      <li className="menu-divider"></li>

      {/* 12. ניהול (בתחתית — כולל סוכנים, משתמשים, פרופיל) */}
      <li
        className={classnames(
          'subMenu',
          routePath.startsWith('/company') ||
          (routePath.startsWith('/admin') && routePath !== '/admin/send-message') ||
          routePath.startsWith('/bank') ||
          routePath === '/loading-terminal/alternative' ||
          routePath.startsWith('/agent/') ||
          routePath.startsWith('/account') ||
          subAdminMenuShown
            ? 'mm-active cust-mm-active'
            : '',
        )}
      >
        <Link
          to="#"
          className={classnames('has-arrow', subAdminMenuShown ? 'cust-has-arrow' : '')}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            toggleAccordion(setSubAdminMenuShown, subAdminMenuShown);
          }}
        >
          <i className="ri-settings-3-line"></i>
          <span className="ms-1">{t('ADMIN.TITLE')}</span>
        </Link>

        <ul className={classnames('mm-collapse', subAdminMenuShown ? 'mm-show cust-mm-show' : '')}
          style={subAdminMenuShown ? { backgroundColor: '#f0f1f3', borderRadius: '4px' } : {}}>

          {/* התראות */}
          <li
            className={classnames(
              'subMenu',
              routePath.startsWith('/admin/message-role-mapping') || routePath.startsWith('/admin/notification-preferences') || routePath.startsWith('/admin/shabbat-settings') || subAlertsMenuShown
                ? 'mm-active cust-mm-active'
                : '',
            )}
          >
            <Link
              to="#"
              className={classnames('has-arrow', subAlertsMenuShown ? 'cust-has-arrow' : '')}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setSubAlertsMenuShown(!subAlertsMenuShown);
              }}
            >
              <i className="ri-notification-3-line"></i>
              <span className="ms-1">{t('ADMIN.ALERTS_CATEGORY')}</span>
            </Link>

            <ul className={classnames('mm-collapse', subAlertsMenuShown ? 'mm-show cust-mm-show' : '')}
              style={subAlertsMenuShown ? { backgroundColor: '#e4e6ea', borderRadius: '4px', marginTop: '2px' } : {}}>
              <li className={classnames(routePath === '/admin/shabbat-settings' ? 'mm-active' : '')}>
                <NavLink to="/admin/alerts" className="waves-effect">
                  <i className="ri-moon-line"></i>
                  <span className="ms-1">{t('ADMIN.SHABBAT_SETTINGS')}</span>
                </NavLink>
              </li>

              <li className={classnames(routePath === '/admin/message-role-mapping' ? 'mm-active' : '')}>
                <NavLink to="/admin/alerts" className="waves-effect">
                  <i className="ri-mail-settings-line"></i>
                  <span className="ms-1">{t('ADMIN.MESSAGE_ROLE_MAPPING')}</span>
                </NavLink>
              </li>

              <li className={classnames(routePath === '/admin/notification-preferences' ? 'mm-active' : '')}>
                <NavLink to="/admin/alerts" className="waves-effect">
                  <i className="ri-notification-3-line"></i>
                  <span className="ms-1">{t('ADMIN.NOTIFICATION_PREFERENCES')}</span>
                </NavLink>
              </li>
            </ul>
          </li>

          {/* טעינות מסופים מיוחדת */}
          <li className={classnames(routePath === '/loading-terminal/alternative' ? 'mm-active' : '')}>
            <NavLink to="/loading-terminal/alternative" className="waves-effect">
              <i className="ri-calculator-line"></i>
              <span className="ms-1">{t('ADMIN.ALTERNATIVE_LOADING')}</span>
            </NavLink>
          </li>

          {/* פרמטר חישוב */}
          <li className={classnames(routePath === '/admin/company-parameters' ? 'mm-active' : '')}>
            <NavLink to="/admin/company-parameters" className="waves-effect">
              <i className="ri-calculator-line"></i>
              <span className="ms-1">{t('ADMIN.COMPANY_PARAMETERS')}</span>
            </NavLink>
          </li>

          {/* תיקון ידני של אצווה */}
          <li className={classnames(routePath === '/admin/terminal-correction' ? 'mm-active' : '')}>
            <NavLink to="/admin/terminal-correction" className="waves-effect">
              <i className="ri-edit-2-line"></i>
              <span className="ms-1">תיקון ידני של אצווה</span>
            </NavLink>
          </li>

          {/* בנק */}
          <li className={classnames(routePath.startsWith('/bank') ? 'mm-active' : '')}>
            <NavLink to="/bank/list" className="waves-effect">
              <i className="ri-bank-line"></i>
              <span className="ms-1">{t('BANK.TITLE')}</span>
            </NavLink>
          </li>

          {/* סוכנים — הועבר לתוך ניהול */}
          {companyId !== 0 && (
            <li className={routePath.startsWith('/agent/') ? 'mm-active' : ''}>
              <NavLink to="/agent/list" className="waves-effect">
                <i className="ri-user-star-line"></i>
                <span className="ms-1">{t('AGENT.TITLE')}</span>
              </NavLink>
            </li>
          )}

          {/* משתמשים — הועבר מ"חשבון" */}
          <li className={classnames(routePath.startsWith('/account/users') ? 'mm-active' : '')}>
            <NavLink to="/account/users/list" className="waves-effect">
              <i className="ri-team-line"></i>
              <span className="ms-1">{t('USERS_TITLE')}</span>
            </NavLink>
          </li>

          {/* פרופיל — הועבר מ"חשבון" */}
          <li className={classnames(routePath.startsWith('/account/profile') ? 'mm-active' : '')}>
            <NavLink to="/account/profile" className="waves-effect">
              <i className="ri-profile-line"></i>
              <span className="ms-1">{t('PROFILE')}</span>
            </NavLink>
          </li>
        </ul>
      </li>
    </>
  );

  // =====================================================
  // תפריט רגיל — מנהל מערכת, סוכן, עובד (ללא שינוי)
  // =====================================================
  const renderStandardMenu = () => (
    <>
      {/* Dashboard */}
      <li className={routePath.startsWith('/dashboard') ? 'mm-active' : ''}>
        <NavLink to="/dashboard" className="waves-effect">
          <i className="ri-dashboard-line"></i>
          <span className="ms-1">{t('DASHBOARD.TITLE')}</span>
        </NavLink>
      </li>

      {/* Send Message - שליחת הודעות */}
      {roleId === USER_ROLE.SUPER_ADMIN && (
        <li className={routePath === '/admin/send-message' ? 'mm-active' : ''}>
          <NavLink to="/admin/send-message" className="waves-effect">
            <i className="ri-send-plane-line"></i>
            <span className="ms-1">שליחת הודעות</span>
          </NavLink>
        </li>
      )}

      {/* Admin Menu - ניהול */}
      {roleId === USER_ROLE.SUPER_ADMIN && (
        <li
          className={classnames(
            'subMenu',
            routePath.startsWith('/company') || (routePath.startsWith('/admin') && routePath !== '/admin/send-message') || routePath.startsWith('/bank') || routePath === '/loading-terminal/alternative' || subAdminMenuShown
              ? 'mm-active cust-mm-active'
              : '',
          )}
        >
          <Link
            to="#"
            className={classnames('has-arrow', subAdminMenuShown ? 'cust-has-arrow' : '')}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setSubAdminMenuShown(!subAdminMenuShown);
            }}
          >
            <i className="ri-settings-3-line"></i>
            <span className="ms-1">{t('ADMIN.TITLE')}</span>
          </Link>

          <ul className={classnames('mm-collapse', subAdminMenuShown ? 'mm-show cust-mm-show' : '')}
            style={subAdminMenuShown ? { backgroundColor: '#f0f1f3', borderRadius: '4px' } : {}}>
            {roleId === USER_ROLE.SUPER_ADMIN && (
              <li className={classnames(routePath.startsWith('/company') ? 'mm-active' : '')}>
                <NavLink to="/company/list" className="waves-effect">
                  <i className="ri-building-2-line"></i>
                  <span className="ms-1">{t('COMPANY.TITLE')}</span>
                </NavLink>
              </li>
            )}

            {roleId === USER_ROLE.SUPER_ADMIN && (
              <li className={classnames(routePath === '/admin/special-days-config' ? 'mm-active' : '')}>
                <NavLink to="/admin/special-days-config" className="waves-effect">
                  <i className="ri-calendar-event-line"></i>
                  <span className="ms-1">{t('ADMIN.SPECIAL_DAYS_CONFIG')}</span>
                </NavLink>
              </li>
            )}

            {/* Bank - בנק */}
            <li className={classnames(routePath.startsWith('/bank') ? 'mm-active' : '')}>
              <NavLink to="/bank/list" className="waves-effect">
                <i className="ri-bank-line"></i>
                <span className="ms-1">{t('BANK.TITLE')}</span>
              </NavLink>
            </li>

            {/* Alerts sub-category - התראות */}
            <li
              className={classnames(
                'subMenu',
                routePath.startsWith('/admin/message-role-mapping') || routePath.startsWith('/admin/notification-preferences') || routePath.startsWith('/admin/shabbat-settings') || subAlertsMenuShown
                  ? 'mm-active cust-mm-active'
                  : '',
              )}
            >
              <Link
                to="#"
                className={classnames('has-arrow', subAlertsMenuShown ? 'cust-has-arrow' : '')}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  setSubAlertsMenuShown(!subAlertsMenuShown);
                }}
              >
                <i className="ri-notification-3-line"></i>
                <span className="ms-1">{t('ADMIN.ALERTS_CATEGORY')}</span>
              </Link>

              <ul className={classnames('mm-collapse', subAlertsMenuShown ? 'mm-show cust-mm-show' : '')}
                style={subAlertsMenuShown ? { backgroundColor: '#e4e6ea', borderRadius: '4px', marginTop: '2px' } : {}}>
                <li className={classnames(routePath === '/admin/message-role-mapping' ? 'mm-active' : '')}>
                  <NavLink to="/admin/alerts" className="waves-effect">
                    <i className="ri-mail-settings-line"></i>
                    <span className="ms-1">{t('ADMIN.MESSAGE_ROLE_MAPPING')}</span>
                  </NavLink>
                </li>

                <li className={classnames(routePath === '/admin/notification-preferences' ? 'mm-active' : '')}>
                  <NavLink to="/admin/alerts" className="waves-effect">
                    <i className="ri-notification-3-line"></i>
                    <span className="ms-1">{t('ADMIN.NOTIFICATION_PREFERENCES')}</span>
                  </NavLink>
                </li>

                <li className={classnames(routePath === '/admin/shabbat-settings' ? 'mm-active' : '')}>
                  <NavLink to="/admin/alerts" className="waves-effect">
                    <i className="ri-moon-line"></i>
                    <span className="ms-1">{t('ADMIN.SHABBAT_SETTINGS')}</span>
                  </NavLink>
                </li>
              </ul>
            </li>

            {/* Company Parameters - פרמטרי חישוב */}
            <li className={classnames(routePath === '/admin/company-parameters' ? 'mm-active' : '')}>
              <NavLink to="/admin/company-parameters" className="waves-effect">
                <i className="ri-calculator-line"></i>
                <span className="ms-1">{t('ADMIN.COMPANY_PARAMETERS')}</span>
              </NavLink>
            </li>

            {/* Alternative Loading - טעינת מסופים מיוחדת */}
            <li className={classnames(routePath === '/loading-terminal/alternative' ? 'mm-active' : '')}>
              <NavLink to="/loading-terminal/alternative" className="waves-effect">
                <i className="ri-calculator-line"></i>
                <span className="ms-1">{t('ADMIN.ALTERNATIVE_LOADING')}</span>
              </NavLink>
            </li>
          </ul>
        </li>
      )}

      {/* Agents */}
      {companyId !== 0 && (roleId === USER_ROLE.SUPER_ADMIN) && (
        <li className={routePath.substring(0, '/agent/'.length) === '/agent/' ? 'mm-active' : ''}>
          <NavLink to="/agent/list" className="waves-effect">
            <i className="ri-user-star-line"></i>
            <span className="ms-1">{t('AGENT.TITLE')}</span>
          </NavLink>
        </li>
      )}

      {/* Agent Activity */}
      {companyId !== 0 && roleId !== USER_ROLE.EMPLOYEE && (
        <li
          className={classnames(
            'subMenu',
            routePath.substring(0, '/agent-activity'.length) === '/agent-activity' || subMenuShown
              ? 'mm-active cust-mm-active'
              : '',
          )}
        >
          <Link
            to="#"
            className={classnames('has-arrow', subMenuShown ? 'cust-has-arrow' : '')}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setSubMenuShown(!subMenuShown);
            }}
          >
            <i className="ri-contacts-fill"></i>
            <span className="ms-1">{t('AGENT_ACTIVITY')}</span>
          </Link>

          <ul className={classnames('mm-collapse', subMenuShown ? 'mm-show cust-mm-show' : '')}
            style={subMenuShown ? { backgroundColor: '#f0f1f3', borderRadius: '4px' } : {}}>
            <li className={classnames(routePath === '/agent-activity/bank-withdrawal' ? 'mm-active' : '')}>
              <NavLink to="/agent-activity/bank-withdrawal" className="waves-effect">
                <i className="ri-uninstall-line"></i>
                <span className="ms-1">{t('BANK_WITHDRAWAL.TITLE')}</span>
              </NavLink>
            </li>

            <li className={classnames(routePath === '/agent-activity/split-money' ? 'mm-active' : '')}>
              <NavLink to="/agent-activity/split-money" className="waves-effect">
                <i className="ri-refund-2-line"></i>
                <span className="ms-1">{t('SPLIT_MONEY.TITLE')}</span>
              </NavLink>
            </li>
          </ul>
        </li>
      )}

      {/* Employee */}
      {companyId !== 0 && roleId === USER_ROLE.SUPER_ADMIN && (
        <li className={routePath.substring(0, '/employee/'.length) === '/employee/' ? 'mm-active' : ''}>
          <NavLink to="/employee/list" className="waves-effect">
            <i className="ri-user-2-line"></i>
            <span className="ms-1">{t('EMPLOYEE.TITLE')}</span>
          </NavLink>
        </li>
      )}

      {/* Employee Activity */}
      {companyId !== 0 && (
        <li
          className={classnames(
            'subMenu',
            routePath.substring(0, '/employee-activity'.length) === '/employee-activity' || subEmpMenuShown
              ? 'mm-active cust-mm-active'
              : '',
          )}
        >
          <Link
            to="#"
            className={classnames('has-arrow', subEmpMenuShown ? 'cust-has-arrow' : '')}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setSubEmpMenuShown(!subEmpMenuShown);
            }}
          >
            <i className="ri-contacts-line"></i>
            <span className="ms-1">{t('EMP_ACTIVITY')}</span>
          </Link>

          <ul className={classnames('mm-collapse', subEmpMenuShown ? 'mm-show cust-mm-show' : '')}
            style={subEmpMenuShown ? { backgroundColor: '#f0f1f3', borderRadius: '4px' } : {}}>
            <li className={classnames(routePath === '/employee-activity/bank-withdrawal' ? 'mm-active' : '')}>
              <NavLink to="/employee-activity/bank-withdrawal" className="waves-effect">
                <i className="ri-uninstall-line"></i>
                <span className="ms-1">{t('BANK_WITHDRAWAL.TITLE')}</span>
              </NavLink>
            </li>

            <li className={classnames(routePath === '/employee-activity/charging-terminal' ? 'mm-active' : '')}>
              <NavLink to="/employee-activity/charging-terminal" className="waves-effect">
                <i className="ri-fridge-line"></i>
                <span className="ms-1">{t('CHARGE_TERMINAL.TITLE')}</span>
              </NavLink>
            </li>

            <li className={classnames(routePath === '/employee-activity/split-money' ? 'mm-active' : '')}>
              <NavLink to="/employee-activity/split-money" className="waves-effect">
                <i className="ri-refund-2-line"></i>
                <span className="ms-1">{t('SPLIT_MONEY.TITLE')}</span>
              </NavLink>
            </li>

            <li className={classnames(routePath === '/employee-activity/withdrawal-terminal' ? 'mm-active' : '')}>
              <NavLink to="/employee-activity/withdrawal-terminal" className="waves-effect">
                <i className="ri-fridge-line"></i>
                <span className="ms-1">{t('WITHDRAWAL_TERMINAL')}</span>
              </NavLink>
            </li>
          </ul>
        </li>
      )}

      {(roleId === USER_ROLE.EMPLOYEE) && (
        <li className={routePath === '/loading-terminal/terminal-loads' ? 'mm-active' : ''}>
          <NavLink to="/loading-terminal/terminal-loads" className="waves-effect">
            <i className="ri-currency-line"></i>
            <span className="ms-1">{t('EMPLOYEE_LOADS.TITLE')}</span>
          </NavLink>
        </li>
      )}

      {/* Location */}
      {companyId !== 0 && (
        <li className={routePath.startsWith('/locations') ? 'mm-active' : ''}>
          <NavLink to="/locations/list" className="waves-effect">
            <i className="ri-map-pin-5-line"></i>
            <span className="ms-1">{t('LOCATION.TITLE')}</span>
          </NavLink>
        </li>
      )}

      {/* Terminal / Machines */}
      {companyId !== 0 && roleId !== USER_ROLE.EMPLOYEE && (
        <li className={routePath.startsWith('/terminal') ? 'mm-active' : ''}>
          <NavLink to="/terminal/list" className="waves-effect">
            <i className="ri-safe-line"></i>
            <span className="ms-1">{t('MACHINE.TITLE')}</span>
          </NavLink>
        </li>
      )}

      {/* Loading terminal per day */}
      {roleId === USER_ROLE.SUPER_ADMIN && (
        <li className={routePath === '/loading-terminal/list' ? 'mm-active' : ''}>
          <NavLink to="/loading-terminal/list" className="waves-effect">
            <i className="ri-currency-line"></i>
            <span className="ms-1">{t('LOADING_TERMINAL.TITLE')}</span>
          </NavLink>
        </li>
      )}

      <li className={routePath === '/cash-expense' ? 'mm-active' : ''}>
        <NavLink to="/cash-expense/list" className="waves-effect">
          <i className="ri-currency-line"></i>
          <span className="ms-1">{t('CASHEXPENSE.TITLE')}</span>
        </NavLink>
      </li>

      {/* Report */}
      {companyId !== 0 && roleId === USER_ROLE.SUPER_ADMIN && (
        <li
          className={classnames(
            'subMenu',
            routePath.substring(0, '/report'.length) === '/report' || subReportMenuShown
              ? 'mm-active cust-mm-active'
              : '',
          )}
        >
          <Link
            to="#"
            className={classnames('has-arrow', subReportMenuShown ? 'cust-has-arrow' : '')}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setSubReportMenuShown(!subReportMenuShown);
            }}
          >
            <i className="ri-file-chart-line"></i>
            <span className="ms-1">{t('REPORT.TITLE')}</span>
          </Link>

          <ul className={classnames('mm-collapse', subReportMenuShown ? 'mm-show cust-mm-show' : '')}
            style={subReportMenuShown ? { backgroundColor: '#f0f1f3', borderRadius: '4px' } : {}}>
            <li className={classnames(routePath === '/report/agent-cash-expense' ? 'mm-active' : '')}>
              <NavLink to="/report/agent-cash-expense" className="waves-effect">
                <i className="ri-wallet-3-line"></i>
                <span className="ms-1">{t('REPORT.AGENTCASHEXPENSE')}</span>
              </NavLink>
            </li>

            <li className={classnames(routePath === '/report/reference' ? 'mm-active' : '')}>
              <NavLink to="/report/reference" className="waves-effect">
                <i className="ri-survey-line"></i>
                <span className="ms-1">{t('REPORT.REPORT_REFER')}</span>
              </NavLink>
            </li>

            <li className={classnames(routePath === '/report/terminal' ? 'mm-active' : '')}>
              <NavLink to="/report/terminal" className="waves-effect">
                <i className="ri-list-check-2"></i>
                <span className="ms-1">{t('REPORT.TERMINAL_REPORT')}</span>
              </NavLink>
            </li>

            <li className={classnames(routePath === '/report/withdrawal-count' ? 'mm-active' : '')}>
              <NavLink to="/report/withdrawal-count" className="waves-effect">
                <i className="ri-bar-chart-2-line"></i>
                <span className="ms-1">{t('WITHDRAWAL_REPORT.TITLE')}</span>
              </NavLink>
            </li>

            <li className={classnames(routePath === '/report/loading-gap' ? 'mm-active' : '')}>
              <NavLink to="/report/loading-gap" className="waves-effect">
                <i className="ri-funds-box-line"></i>
                <span className="ms-1">פערים בין טעינות</span>
              </NavLink>
            </li>

            <li className={classnames(routePath === '/report/employee-loading-gaps-cumulative' ? 'mm-active' : '')}>
              <NavLink to="/report/employee-loading-gaps-cumulative" className="waves-effect">
                <i className="ri-line-chart-line"></i>
                <span className="ms-1">פערים מצטבר פר עובד</span>
              </NavLink>
            </li>

            <li className={classnames(routePath === '/report/check-flow' ? 'mm-active' : '')}>
              <NavLink to="/report/check-flow" className="waves-effect">
                <i className="ri-exchange-funds-line"></i>
                <span className="ms-1">זרימת כסף</span>
              </NavLink>
            </li>

            <li className={classnames(routePath === '/report/employee-balance' ? 'mm-active' : '')}>
              <NavLink to="/report/employee-balance" className="waves-effect">
                <i className="ri-money-dollar-circle-line"></i>
                <span className="ms-1">יתרת עובדים</span>
              </NavLink>
            </li>

            <li className={classnames(routePath === '/report/batch-lines-reconciliation' ? 'mm-active' : '')}>
              <NavLink to="/report/batch-lines-reconciliation" className="waves-effect">
                <i className="ri-file-list-3-line"></i>
                <span className="ms-1">הצלבת אצוות חשבוניות</span>
              </NavLink>
            </li>

            <li className={classnames(routePath === '/report/casponet-invoice-verification' ? 'mm-active' : '')}>
              <NavLink to="/report/casponet-invoice-verification" className="waves-effect">
                <i className="ri-file-check-line"></i>
                <span className="ms-1">אימות חשבונית כספונט</span>
              </NavLink>
            </li>

            <li className={classnames(routePath === '/report/missing-invoice-batches' ? 'mm-active' : '')}>
              <NavLink to="/report/missing-invoice-batches" className="waves-effect">
                <i className="ri-error-warning-line"></i>
                <span className="ms-1">אצוות חסרות מ-Casponet</span>
              </NavLink>
            </li>
          </ul>
        </li>
      )}

      {/* Profitability */}
      {companyId !== 0 && roleId === USER_ROLE.SUPER_ADMIN && (
        <li
          className={classnames(
            'subMenu',
            routePath.startsWith('/profitability') || subProfitMenuShown
              ? 'mm-active cust-mm-active'
              : '',
          )}
        >
          <Link
            to="#"
            className={classnames('has-arrow', subProfitMenuShown ? 'cust-has-arrow' : '')}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setSubProfitMenuShown(!subProfitMenuShown);
            }}
          >
            <i className="ri-line-chart-line"></i>
            <span className="ms-1">{t('PROFITABILITY.TITLE')}</span>
          </Link>

          <ul className={classnames('mm-collapse', subProfitMenuShown ? 'mm-show cust-mm-show' : '')}
            style={subProfitMenuShown ? { backgroundColor: '#f0f1f3', borderRadius: '4px' } : {}}>
            {/* 1. שיוך חשבוניות סרוקות */}
            <li className={classnames(routePath === '/profitability/invoice-scan' ? 'mm-active' : '')}>
              <NavLink to="/profitability/invoice-scan" className="waves-effect">
                <i className="ri-scan-2-line"></i>
                <span className="ms-1">{t('PROFITABILITY.INVOICE_SCAN')}</span>
              </NavLink>
            </li>
            {/* 2. רווחיות לחודש */}
            <li className={classnames(routePath === '/profitability/monthly-report' ? 'mm-active' : '')}>
              <NavLink to="/profitability/monthly-report" className="waves-effect">
                <i className="ri-bar-chart-grouped-line"></i>
                <span className="ms-1">{t('PROFITABILITY.MONTHLY_REPORT')}</span>
              </NavLink>
            </li>
            {/* 3. תשלום למקומות */}
            <li className={classnames(routePath === '/profitability/payment-schedule' ? 'mm-active' : '')}>
              <NavLink to="/profitability/payment-schedule" className="waves-effect">
                <i className="ri-calendar-check-line"></i>
                <span className="ms-1">{t('PROFITABILITY.PAYMENT_SCHEDULE')}</span>
              </NavLink>
            </li>
            {/* 4. חשבוניות מקומות */}
            <li className={classnames(routePath === '/profitability/invoices' ? 'mm-active' : '')}>
              <NavLink to="/profitability/invoices" className="waves-effect">
                <i className="ri-file-list-3-line"></i>
                <span className="ms-1">{t('PROFITABILITY.INVOICES')}</span>
              </NavLink>
            </li>
            {/* 5. חשבוניות ספקים */}
            <li className={classnames(routePath === '/profitability/expenses' ? 'mm-active' : '')}>
              <NavLink to="/profitability/expenses" className="waves-effect">
                <i className="ri-wallet-2-line"></i>
                <span className="ms-1">{t('PROFITABILITY.EXPENSES')}</span>
              </NavLink>
            </li>
            {/* 5.5 חשבוניות הכנסה (RevenueInvoice) */}
            <li className={classnames(routePath === '/profitability/revenue-invoices' ? 'mm-active' : '')}>
              <NavLink to="/profitability/revenue-invoices" className="waves-effect">
                <i className="ri-money-dollar-circle-line"></i>
                <span className="ms-1">{t('PROFITABILITY.REVENUE_INVOICES')}</span>
              </NavLink>
            </li>
            {/* 6. שכר עובדים */}
            <li className={classnames(routePath === '/profitability/salary' ? 'mm-active' : '')}>
              <NavLink to="/profitability/salary" className="waves-effect">
                <i className="ri-user-star-line"></i>
                <span className="ms-1">{t('PROFITABILITY.SALARY')}</span>
              </NavLink>
            </li>
            {/* 7. ניהול ריכוז ספקים */}
            <li className={classnames(routePath === '/profitability/location-groups' ? 'mm-active' : '')}>
              <NavLink to="/profitability/location-groups" className="waves-effect">
                <i className="ri-map-pin-2-line"></i>
                <span className="ms-1">{t('PROFITABILITY.LOCATION_GROUPS')}</span>
              </NavLink>
            </li>
          </ul>
        </li>
      )}

      {/* Special days */}
      {companyId !== 0 && roleId !== USER_ROLE.EMPLOYEE && (
        <li className={routePath.startsWith('/special-days') ? 'mm-active' : ''}>
          <NavLink to="/special-days/list" className="waves-effect">
            <i className="ri-calendar-2-line"></i>
            <span className="ms-1">{t('SPECIAL_DAYS.TITLE')}</span>
          </NavLink>
        </li>
      )}

      <li className="menu-title">{t('ACCOUNT.TITLE')}</li>

      {/* User Profile */}
      <li className={routePath.substring(0, '/account/profile'.length) === '/account/profile' ? 'mm-active' : ''}>
        <NavLink to="/account/profile" className="waves-effect">
          <i className="ri-profile-line"></i>
          <span className="ms-1">{t('PROFILE')}</span>
        </NavLink>
      </li>

      {/* Users */}
      {roleId === USER_ROLE.SUPER_ADMIN && (
        <li className={routePath.substring(0, '/account/users'.length) === '/account/users' ? 'mm-active' : ''}>
          <NavLink to="/account/users/list" className="waves-effect">
            <i className="ri-team-line"></i>
            <span className="ms-1">{t('USERS_TITLE')}</span>
          </NavLink>
        </li>
      )}
    </>
  );

  return (
    <React.Fragment>
      <div id="sidebar-menu">
        <MetisMenu className="list-unstyled" id="side-menu">
          <li className="menu-title">{t('MENU')}</li>
          {isCompanyAdmin ? renderCompanyAdminMenu() : renderStandardMenu()}
        </MetisMenu>
      </div>
    </React.Fragment>
  );
}

export default SidebarContent;
